import { useEffect } from 'react'
import { HERO_SIGNATURE_EVENT,type HeroSignatureEventDetail } from './HeroCombatRuntimeBridge'
import { heroPerformanceRumblePlan } from './heroPerformanceRuntime'
import { useFightStore } from './store'

type RumbleActuator={playEffect?:(type:string,params:{duration:number;strongMagnitude:number;weakMagnitude:number})=>Promise<unknown>|unknown}
export function playRumbleEffect(actuator:RumbleActuator|undefined,strong:number,weak:number,duration:number){
 if(!actuator?.playEffect)return
 try{
  const result=actuator.playEffect('dual-rumble',{duration,strongMagnitude:strong,weakMagnitude:weak})
  if(result&&typeof (result as PromiseLike<unknown>).then==='function')void Promise.resolve(result).catch(()=>undefined)
 }catch{}
}
function rumble(pad:Gamepad|null|undefined,strong:number,weak:number,duration:number){const actuator=(pad as (Gamepad&{vibrationActuator?:RumbleActuator})|null|undefined)?.vibrationActuator;playRumbleEffect(actuator,strong,weak,duration)}

export function ImpactHaptics(){
 useEffect(()=>{
  const unsubscribe=useFightStore.subscribe((state,previous)=>{
   if(state.impactSerial===previous.impactSerial||!state.impactCue)return
   const pads=navigator.getGamepads?.()??[],cue=state.impactCue,breakWeight=cue.stageBreakState==='collapsed'?1.35:cue.stageBreakState==='broken'?1.18:cue.stageBreakState==='cracked'?1.06:1,weight=(cue.kind==='guard-break'?1:cue.kind==='throw'?.9:cue.kind==='parry'?.82:cue.kind==='hit'?.68:.42)*breakWeight,duration=cue.stageBreakState==='collapsed'?145:cue.kind==='throw'?120:95
   if(state.mode==='local'){
    if(cue.source==='player'){rumble(pads[0],.22*weight,.42*weight,cue.kind==='throw'?92:70);rumble(pads[1],.68*weight,.9*weight,duration)}
    else{rumble(pads[1],.22*weight,.42*weight,cue.kind==='throw'?92:70);rumble(pads[0],.68*weight,.9*weight,duration)}
   }else rumble(pads[0],cue.source==='enemy'?.76*weight:.32*weight,cue.source==='enemy'?.94*weight:.56*weight,cue.kind==='throw'?125:cue.source==='enemy'?100:72)
  })
  const onSignature=(event:Event)=>{
   const detail=(event as CustomEvent<HeroSignatureEventDetail>).detail
   if(!detail?.performance)return
   const state=useFightStore.getState(),plan=heroPerformanceRumblePlan(detail.performance,detail.side,state.mode==='local'),pads=navigator.getGamepads?.()??[]
   rumble(pads[plan.padIndex],plan.strong,plan.weak,plan.duration)
  }
  window.addEventListener(HERO_SIGNATURE_EVENT,onSignature)
  return()=>{unsubscribe();window.removeEventListener(HERO_SIGNATURE_EVENT,onSignature)}
 },[])
 return null
}
